export default "__VITE_ASSET__b1251924__"